import angular from 'angular'
import './collector_levels.service'
import './edit/edit.controller'

angular
  .module('admin.collector_levels', [
    'admin.collector_level.service',
    'admin.collector_levels.edit',
  ])
  .controller('CollectorLevelsCtrl', CollectorLevelsCtrl)

/** @ngInject */
function CollectorLevelsCtrl(CollectorLevelService) {
  var vm = this
  vm.items = []

  load()

  function load() {
    CollectorLevelService.list().then(function(result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i].editing = false
      }
      vm.items = result.results
    })
  }

  vm.save = function(item) {
    CollectorLevelService.update(item.id, item).then(function() {
      load()
    })
  }
}
